import { Link } from 'react-router-dom';
import './Decay.css';
import logo_decay from "./logo_decay.png"
import trailer from "./trailer.mp4"

function Decay() {
  return (
    <main className='Decay'>
      <section className='Decay-TitleBar'>
        <img src={logo_decay} className='Decay-Image' type="image/png" alt="The logo of the game titled 'Decay', 
        which consists of a dark grey letter 'D' with slices removed from the lower half, as if the letter itself is
        decaying." />
        <section className='Decay-TitleBar-Content'>
          <h1>
            Decay
          </h1>
          <p>
            Decay is an incremental game in which you are tasked with using your trusty particle launcher (which may or
            may not have been found in a dumpster out back of the laboratory) to create ever-larger and more unstable
            atomic nuclei, witnessing longer and more complex atomic decay chains and aiming to discover all the
            isotopes!
          </p>
          <section className='Decay-TitleBar-Content-Buttons'>
            <Link to="https://store.steampowered.com/app/4594750/Decay/" className='Decay-TitleBar-Content-Buttons-Activated'>
              Check out Decay on the Steam Store <br/>(coming May 2026)
            </Link>
            <Link to="../mailing-list" className='Decay-TitleBar-Content-Buttons-Activated'>
              Subscribe to the mailing list to be kept up-to-date with all the latest news
            </Link>
          </section>
          <section className='Decay-TitleBar-Content-Buttons'>
            <a href='/press/DecayPressPack.zip' download className='Decay-TitleBar-Content-Buttons-Activated'>
              Download the Decay press pack
            </a>
          </section>
        </section>
      </section>
      <video controls>
        <source src={trailer} type="video/mp4"/>
        Your browser does not support the video tag.
      </video>
      <section className='Decay-Features'>
        <h1>
          GAMEPLAY FEATURES
        </h1>
        <ul>
          <li>
            <strong>LAUNCH PARTICLES - </strong> Create your concoction of protons and neutrons to forge atomic nuclei
            in your (very scientific) question to discover new and ever more unstable nuclei.
          </li>
          <li>
            <strong>UPGRADE YOUR LAB - </strong> Unlock a wide range of upgrades to improve your laboratory and expand
            your capabilities.
          </li>
          <li>
            <strong>AUTOMATE AND EXPAND - </strong> Build additional test chambers and set them to automate multiple
            experiments in parallel.
          </li>
          <li>
            <strong>DISCOVER RARE ISOTOPES - </strong> With hundreds of isotopes available to be discovered, can you
            find all the combinations?
          </li>
          <li>
            <strong>OBSERVE REAL SCIENCE - </strong> Study the real decay chains of atomic nuclei. Do you, like all
            <em> very normal</em> people, have a favourite isotope? See how it is formed, and how it might decay!
          </li>
        </ul>
      </section>
      <section className='Decay-Features'>
        <h1>
          ADDITIONAL INFORMATION
        </h1>
        <ul>
          <li>
            <strong>BUY ONCE, PLAY FOREVER - </strong> We at Racctuality are committed to a policy that ensures those 
            purchase our games are entitled to any future updates, never locking future gameplay content behind a
            paywall for a game you have already purchased. So long as the choice is ours to make, paid gameplay DLC will
            never exist for our games. <em>(The only exception to this rule will be if ever we release purely
            non-gameplay content, for example concept art or a soundtrack.)</em>
          </li>
        </ul>
      </section>
    </main>
  );
}

export default Decay;
